import {observable,computed} from 'mobx';


class UI {
  CardSize(){
    if(window.innerWidth>1024){
      return 250
    }else if(window.innerWidth<768){
      return 150
    }else{
      return 100
    }
  }
}
var ui = new UI;

export default ui;



// WEBPACK FOOTER //
// ./src/store/ui.js